module.exports = __webpack_public_path__ + "static/6-7ff62cd7c72eba27ce9e4156a3b6163e.png";